// extracted by mini-css-extract-plugin
module.exports = {"component":"settings_component__KLzgS","divider":"settings_divider__W-8Rj","selected":"settings_selected__1-QUA"};